import NotificationTrackingEvent from './NotificationTrackingEvent';

export default class UserUnsubscribedFromNotificationTrackingEvent extends NotificationTrackingEvent {
  constructor(notificationName: string, instrumentType: string) {
    super('user-unsubscribed-from-notification', { notificationName, instrumentType });
  }
}
